<label
  class="ui-checkbox"
  [ngClass]="{
    'ui-checkbox-disabled': disabled,
    'ui-checkbox-checked': checked,
    'ui-checkbox-focused': focused && !disabled,
    'ui-checkbox-invalid': hasError && !checked
  }"
>
  <input
    type="checkbox"
    [ngModel]="checked"
    (ngModelChange)="onModelChange($event)"
    (focus)="toggleFocus(true)"
    (blur)="toggleFocus(false)"
  />
  <ng-content></ng-content>
</label>
